import { useAnalytics } from 'hooks/analytics/useAnalytics';

export function Analytics() {
  useAnalytics();
  return <></>;
}
